'use client';

import { amazonColors } from '../../constants/colors';
import { Box, Flex, HStack, Text } from '@skin-seoul/design-system';
import { isNil } from 'es-toolkit';
import { formatCurrency } from '@skin-seoul/service';
import type { Currency } from '@skin-seoul/service';
import TicketIcon from './TicketIcon';
interface PriceOnAmazonProps {
  price: string | number;
  currency: Currency;
}
export const PriceOnAmazon = ({
  price,
  currency
}: PriceOnAmazonProps) => {
  return <Flex alignItems="center" justifyContent="center" width="100%" height="fit-content" background="linear-gradient(180deg, rgba(5, 120, 255, 0) 0%, rgba(5, 120, 255, 0.4) 100%)" paddingTop="20px" paddingBottom="8px" data-sentry-element="Flex" data-sentry-component="PriceOnAmazon" data-sentry-source-file="PriceOnAmazon.tsx">
      <HStack gap={{
      base: '4px',
      tablet: '8px'
    }} alignItems="center" height="100%" data-sentry-element="HStack" data-sentry-source-file="PriceOnAmazon.tsx">
        <Box width="20px" height="20px" display="flex" alignItems="center" justifyContent="center" css={{
        '@media (max-width: 420px)': {
          display: 'none'
        }
      }} data-sentry-element="Box" data-sentry-source-file="PriceOnAmazon.tsx">
          <TicketIcon data-sentry-element="TicketIcon" data-sentry-source-file="PriceOnAmazon.tsx" />
        </Box>
        {isNil(price) ? <Text textStyle={{
        base: 'label.xsmall',
        tablet: 'label.small'
      }} fontWeight="normal" color="#232F3E" whiteSpace="nowrap">
            Wow-Level Price
          </Text> : <>
            <Text textStyle={{
          base: 'label.xsmall',
          tablet: 'label.small'
        }} fontWeight="normal" color="#232F3E" whiteSpace="nowrap">
              Price On Amazon
            </Text>

            <Box backgroundColor={amazonColors.prime.blue} height="20px" borderRadius="6px" display="flex" alignItems="center" justifyContent="center" paddingX="4px">
              <Text textStyle={{
            base: 'label.xsmall',
            tablet: 'label.small'
          }} fontWeight="semibold" color={amazonColors.prime.yellow} whiteSpace="nowrap">
                {formatCurrency(currency, price)}
              </Text>
            </Box>
          </>}
      </HStack>
    </Flex>;
};
export default PriceOnAmazon;